// extracted by mini-css-extract-plugin
export default {"signUpForm":"SignUpForm_signUpForm__3kuqn","inputBox":"SignUpForm_inputBox__u2Dzd","userInput":"SignUpForm_userInput__9fDMF"};